import React from 'react';
import { Link } from 'react-router-dom';
import TopHeader from '../components/TopHeader'
import { useLocation } from "react-router-dom"
import GoogleMapReact from "google-map-react"
import LocationMarkerBusinessDetail from "./LocationMarkerBusinessDetail"
import { useNavigate } from "react-router-dom";
import { useGetPOIsQuery } from "../store/atfPoiApiSlice";

import SanitisedHtml from './SanitisedHtml'

import _ from 'lodash'

function BusinessSingle() {
    const { data: entities = [], isFetching: poisFetching } = useGetPOIsQuery();

    const {state} = useLocation()

    const selectedBusinessCategory = state.category.id;

    const navigate = useNavigate();
    const goToBusinessDetails = (entity, category) => {
        window.scrollTo(0, 0)
        navigate('/business-single', {state: {
            entity: entity,
            category: category
        }})
    }

    const goToMap = () => {
        navigate('/');
    }

    const relatedEntities = _.chain(entities)
        .filter(e => {
            return _.includes(e.atf_category, selectedBusinessCategory) && e.id !== state.entity.id;
        })
        .take(3)
        .value();

    return (

        <div className='business-single-wrapper h-100'>
            <TopHeader/>

            <div className="business-info-wrapper md:py-20 py-10">
                <a href='#' onClick={goToMap} className="business-details-btn">{"<< Back to map"}</a>

                <div className="business-main-wapper lg:mx-40 md:mx-10 bg-white h-100 mx-5 lg:shadow-md">
                   

                    <div className="business-info-inner-wrapper">

                        <h1 className='text-2xl listing-title text-center mb-5'>
                            <SanitisedHtml html={state.entity.title.rendered} as='span' /></h1>
                        <h4 className='business-category text-center mb-5'>
                            <SanitisedHtml html={state.category.name} as='span' /></h4>

                    </div>

                    <div
                        className="flex flex-wrap -mx-5 overflow-hidden sm:-mx-5 md:-mx-5 lg:-mx-5 xl:-mx-5">

                        <div
                            className="my-5 px-5 w-full overflow-hidden sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 business-blocks shadow-md">
                            <h2 className='business-block-b-name'>
                                <SanitisedHtml html={state.entity.title.rendered} as='span' /></h2>
                            <div className='business-block-b-details text-black mt-5'>
                                <SanitisedHtml html={state.entity.content.rendered} /></div>
                        </div>

                        <div
                            className="my-5 px-5 w-full overflow-hidden sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2"
                            >
                                <img className="business-second-image" src={state.entity.atf_featured_image || ""} alt=""/>
                        </div>

                        <div
                            className="my-5 px-5 w-full overflow-hidden sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 business-blocks shadow-md">

                            <h2 className='business-block-b-name'>Contact Details</h2>
                            <div className='business-block-b-details text-black'>

                                <ul className="w-full rounded-lg mt-2 mb-3">
                                    <li className="mb-1">
                                        <span className="w-fill flex p-3 pl-3 rounded-lg">
                                            <svg
                                                className="h-8 w-8 text-green-500"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round">
                                                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                                                <circle cx="12" cy="10" r="3"/></svg>
                                            <span
                                                className="ml-2 text-lg b-details-btn-text"
                                                title="Address">
                                                <b>Address: </b>
                                                {state.entity.meta.atf_address}
                                            </span>
                                        </span>
                                    </li>

                                    <li className="mb-1">
                                        <a href={`tel:${state.entity.meta.atf_phone}`} className="w-fill flex p-3 pl-3 rounded-lg">
                                            <svg
                                                className="h-8 w-8 text-green-500"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor">
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                                            </svg>

                                            <span
                                                className="ml-2 text-lg b-details-btn-text"
                                                title="Phone">
                                                <b>Phone: </b>
                                                {state.entity.meta.atf_phone}
                                            </span>
                                        </a>
                                    </li>

                                    <li className="mb-1">
                                        <a href={`mailto:${state.entity.meta.atf_email}`} className="w-fill flex p-3 pl-3 rounded-lg">
                                            <svg
                                                className="h-8 w-8 text-green-500"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round">
                                                <path
                                                    d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                                                <polyline points="22,6 12,13 2,6"/></svg>

                                            <span
                                                className="ml-2 text-lg b-details-btn-text"
                                                title="Email">
                                                <b>Email: </b>
                                                {state.entity.meta.atf_email}
                                            </span>
                                        </a>
                                    </li>

                                    <li className="mb-1">
                                        <span className="w-fill flex p-3 pl-3 rounded-lg">
                                            <svg
                                                className="h-8 w-8 text-green-500"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round">
                                                <circle cx="12" cy="12" r="10"/>
                                                <polyline points="12 6 12 12 16 14"/></svg>
                                            <span
                                                className="ml-2 text-lg b-details-btn-text"
                                                title="Working Hours">
                                                <b>Working Hours: </b>
                                                {state.entity.meta.atf_hours}
                                            </span>
                                        </span>
                                    </li>

                                    

                                </ul>

                                

                             
                                <a className="text-white px-32 py-3  text-1xl font-mediumtransition duration-300 w-full business-details-btn" target={'_blank'} rel="noreferrer"
                                    href={state.entity.meta.atf_website + "?utm_source=atf&utm_medium=web&utm_campaign=atf-" + state.entity.slug + "&utm_content=atf&utm_term=atf"}>
                                        Visit Website</a>
                            </div>

                        </div>

                        <div className="my-5 px-5 w-full overflow-hidden sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">
                            {/* <img src="map.png" alt=""/>     */}
                            <GoogleMapReact
                                bootstrapURLKeys={{ key: 'AIzaSyBr5bbagqBVo3NNL_1vyBhlDhEeoJ5vq3Y'}}
                                center={{lat: parseFloat(state.entity.meta.atf_latitude), lng: parseFloat(state.entity.meta.atf_longitude)}}
                                zoom={17}
                            >
                                <LocationMarkerBusinessDetail />
                            </GoogleMapReact>
                        </div>

                        {/* Related Busiess Div */}

                        <div className="related-business-section-wrapper">
                            <h2 className='text-2xl text-center mb-10 mt-14 related-business-section-title'>Related Businesses From This Category</h2>
                            <div className="related-business-wrapper">
                                {
                                    relatedEntities.map(entity => {
                                        return <div key={entity.id} className="h-full related-card-box shadow-md">
                                                    <div 
                                                        className='business-related-featured-image' 
                                                        style={{backgroundImage: `url(${entity.atf_featured_image || ""})`}}
                                                    ></div>
                        

                                                        <h3 className='related-business-title mt-2'>{entity.title.rendered}</h3>

                                                        <span className="w-fill flex p-3 pl-0 rounded-lg ml-0 mb-5">
                                                            <svg
                                                                className="h-8 w-8 text-green-500"
                                                                fill="none"
                                                                viewBox="0 0 24 24"
                                                                stroke="currentColor">
                                                                <path
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    strokeWidth="2"
                                                                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
                                                            </svg>
                                                            <span
                                                                className="ml-2 text-sm b-related-details-btn-text"
                                                                title="Business Category">
                                                                <b>Business Category: </b>
                                                                <SanitisedHtml html={state.category.name} as='span' />
                                                            </span>
                                                        </span>

                                                        <button className="text-white px-32 py-3  text-1xl font-mediumtransition duration-300 business-details-btn" 
                                                                onClick={() => goToBusinessDetails(entity, state.category)}>Learn More</button>
                                                 </div>
                      
                                        }
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BusinessSingle;
